import React from "react";
import "./EWayBill.scss";
import { EWayBillReviewDataType } from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { ClickSubscriptionIcon } from "../../../assets/images";

type AppProps = {
  setShowFillForm: React.Dispatch<React.SetStateAction<boolean>>;
  data: EWayBillReviewDataType;
  isEWayBillGenerate?: boolean;
};
const EWayBillAction = ({
  setShowFillForm,
  data,
  isEWayBillGenerate,
}: AppProps) => {
  return (
    <div className="e-way-action-box p-0">
      <div className="sub-heading-e-invoice ml-0 p-3">E-Way Bill Actions</div>
      <hr className="m-0"></hr>
      {isEWayBillGenerate &&
      (data?.eway_bill_status === 2 || data?.eway_bill_status === 0) ? (
        <>
          {" "}
          <div>
            <div className="sub-heading-e-invoice mt-3">
              FILL TRANSPORTATION DETAILS
            </div>
          </div>
          <div className="ml-4">
            <div className="mt-3">
              To generate an e-way bill, please click here to
            </div>

            <button
              className="btn btn-outline mt-3"
              onClick={() => setShowFillForm(true)}
            >
              Fill Transportation Details
            </button>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              height: "45%",
              display: "grid",
              placeItems: "center",
            }}
          >
            <img src={ClickSubscriptionIcon} alt="ClickSubscriptionIcon" />
          </div>
          <div
            style={{
              width: "75%",
              margin: "auto",
              textAlign: "center",
              fontSize: "15px",
              fontWeight: 500,
            }}
          >
            Please click on above button to take required action on E-Way Bill.
          </div>
        </>
      )}
    </div>
  );
};

export default EWayBillAction;
